/* eslint-disable react/sort-comp */
import React, { Component, Fragment } from 'react';
import DELETE_ACTIONS from 'src/MultiDeletionFunctionality/@state_manager/actions';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { ContentSwitch, ConfirmDelete } from 'Components';
import { equal, copy } from 'helpers/deep';
import { urlSearchToObject, cleanSearchParams } from 'helpers/urlSearchParams';
import { handlePageSizeChange } from 'helpers/pagination';
import { TEMPLATES, TEMPLATES_EXCEL, SUBMISSIONS, SUPPLIES, TEMPLATE_TO_EXCEL } from 'constants/apis';
import DownloadFromUrl from 'helpers/download';
import Fetch from 'helpers/fetch';
import { buildUrl } from 'helpers/misc';
import rowRules from 'helpers/rowRules';
import menuOptions from 'constants/menuOptions';
import TemplatesDesktop from './TemplatesDesktop/TemplatesDesktop';
import TemplatesMobile from './TemplatesMobile/TemplatesMobile';
import DeletionContext from 'src/MultiDeletionFunctionality/@state/DeletionStateContext';

class Templates extends Component {
  static contextType = DeletionContext;

  constructor(props) {
    super(props);

    const searchValues = {
      'Pinned Templates': { Pinned: true },
      'My Templates': { MyTemplate: true },
      'All Templates': {},
    };

    this.state = {
      tabs: Object.keys(searchValues),
      searchValues,
      powerTableIndex: null,
      itemToDelete: undefined,
      isShowDeleteConfirmation: false,
    };

    this.handlePageSizeChange = handlePageSizeChange('templates').bind(this);
    this.handlePageNumberChange = this.handlePageNumberChange.bind(this);
    this.setPageState = this.setState.bind(this);
    this.handleTabsChange = this.handleTabsChange.bind(this);
    this.onPinClick = this.onPinClick.bind(this);
    this.handleCancelDelete = this.handleCancelDelete.bind(this);
    this.handleProceedDelete = this.handleProceedDelete.bind(this);
    this.handleSearchDownload = this.handleSearchDownload.bind(this);
    this.onOptionClick = this.onOptionClick.bind(this);
    this.rowRules = this.rowRules.bind(this);
  }

  componentDidMount() {
    this.dispatch = this.context.dispatch;
    this.deletionState = this.context.deletionState;

    this.handleSearch();
    this.props.setHeadTitle(i18n.t('head:eCOC Templates'));

    this.dispatch({
      type: DELETE_ACTIONS.UPDATE_DELETION_STATE,
      payload: {
        data: this.props.data.data,
        tableCode: 'template',
        idName: 'Id',
      },
    });

    this.props.setAppState((prevState) => {
      return {
        isNavCollapsed: true,
        templates: {
          ...prevState.templates,
          shouldLoad: true,
        },
      };
    });
  }

  componentDidUpdate(prevProps) {
    this.handleSearch();
    if (!this.props.data.isLoading && prevProps.data.isLoading) {
      this.switchTabs();
      this.props.setAppState((prevState) => {
        // ! Setting the data in the deletion state when component loads:
        this.dispatch({ type: DELETE_ACTIONS.RESET_DELETION_STATE });
        this.dispatch({
          type: DELETE_ACTIONS.UPDATE_DELETION_STATE,
          payload: {
            data: this.props.data.data,
            tableCode: this.props.data.code,
            idName: 'Id',
            selectedItems: this.deletionState.selectedItems,
          },
        });
        this.dispatch({ type: DELETE_ACTIONS.GENERATE_ALLOWED_ITEMS_LIST });

        return {
          ...prevState,
        };
      });
    }

    if (this.props.location !== prevProps.location || prevProps.filterItemValue !== this.props.filterItemValue) {
      this.props.setHeadTitle(i18n.t('head:eCOC Templates'));
    }
  }

  componentWillUnmount() {
    this.props.data.abortController.abort();
    // ! Resetting the data for safety before switching the component:
    this.dispatch = this.context.dispatch;
    this.deletionState = this.context.deletionState;
    this.dispatch({ type: DELETE_ACTIONS.RESET_DELETION_STATE });

    this.props.setAppState((prevState) => {
      return {
        isNavCollapsed: false,
        templates: {
          ...prevState.templates,
          abortController: new AbortController(),
        },
      };
    });
  }

  onOptionClick(code, i) {
    const item = this.props.data.data[i];
    this.setState({
      powerTableIndex: null,
      itemToDelete: item.Id,
      isShowDeleteConfirmation: true,
    });

    switch (code) {
      case 'edit':
        this.props.history.push(`/templates/${item.Id}/edit`);
        break;

      // ! On delete option click:
      case 'delete':
        this.dispatch({
          type: DELETE_ACTIONS.TOGGLE_ADD_ITEM_TO_SELECTED_ITEMS,
          payload: { id: item.Id },
        });
        this.dispatch({
          type: DELETE_ACTIONS.UPDATE_DELETION_STATE,
          payload: { isDeleteConfirmationActive: true },
        });
        break;

      // ! On Multi Delete  option click:
      case 'multiDelete':
        // ! Activating Deletion Mode:
        this.dispatch({ type: DELETE_ACTIONS.GENERATE_ALLOWED_ITEMS_LIST });
        this.dispatch({
          type: DELETE_ACTIONS.ACTIVATE_DELETION_MODE,
          payload: { id: item.Id },
        });
        break;
      case 'copy':
        this.props.setAppState({ isCreatingObject: true });
        Fetch.Post(TEMPLATES, { CopyTemplateId: item.Id })
          .then((resp) => resp.json())
          .then((data) => this.props.history.push(`/templates/${data.DataItem.Id}/edit`))
          .catch(({ response }) => this.props.onAPIError(response, true))
          .finally(() => this.props.setAppState({ isCreatingObject: false }));
        break;
      case 'newSubmission':
        this.props.setAppState({ isCreatingObject: true });
        Fetch.Post(`${SUBMISSIONS}/Template/${item.Id}`)
          .then((data) => data.json())
          .then((json) => this.props.history.push(`/submissions/${json.DataItem.Id}/edit`))
          .then(() => this.props.setAppState({ isCreatingObject: false, formIndex: this.props.isPrepaid ? 0 : 2 }))
          .catch(({ response }) => this.props.onAPIError(response, true))
          .finally(() => this.props.setAppState({ isCreatingObject: false }));
        break;
      case 'newOrder':
        this.props.setAppState({ isCreatingObject: true});
        if (this.props.isPrepaid) {          
          Fetch.Post(`${SUBMISSIONS}/Template/${item.Id}?requireOrder=true`)
            .then((data) => data.json())
            .then((json) => this.props.history.push(`/submissions/${json.DataItem.Id}/edit`))
            .then(() => this.props.setAppState({ isCreatingObject: false, isPrepaidOrder:true, formIndex: this.props.isPrepaid ? 0 : 2 }))
            .catch(({ response }) => this.props.onAPIError(response, true))
            .finally(() => this.props.setAppState({ isCreatingObject: false }));
        }
        else { 
        Fetch.Post(SUPPLIES, { CopyTemplateId: item.Id })
          .then((data) => data.json())
          .then((data) =>
            this.props.setAppState(
              {
                isCreatingObject: false,
                formIndex: 0,
              },
              () => this.props.history.push(`/supplies/${data.DataItem.OrderNumber}/edit`),
            ),
          )
          .catch(({ response }) => this.props.onAPIError(response, true))
          .finally(() => this.props.setAppState({ isCreatingObject: false }));
         }
        break;
      case 'share': {
        this.props.setAppState({ shareId: item.Id, shareCode: 'Template' });
        break;
      }
      case 'excel':
        DownloadFromUrl(`${TEMPLATE_TO_EXCEL}/${item.Id}`).catch(({ response }) =>
          this.props.onAPIError(response, true),
        );
        break;
      default:
        break;
    }
  }

  onPinClick(index) {
    const templates = {
      ...copy(this.props.data),
      abortController: new AbortController(),
    };
    const selectedTemplate = templates.data[index];
    const path = selectedTemplate.Pinned ? 'Unpin' : 'Pin';

    const URL = `${TEMPLATES}/${selectedTemplate.Id}/${path}`;
    templates.data[index].Pinned = !templates.data[index].Pinned;
    this.props.setAppState({ templates });
    Fetch.Post(URL, {})
      .then(() => null)
      .catch(() => null);
  }

  switchTabs() {
    const { data, isLoading, isInitialized, tabIndex } = this.props.data;

    if (tabIndex === 2 || (!isInitialized && !isLoading && data.length !== 0)) {
      // ! Setting the data in the deletion state when tab is changed:
      this.dispatch({
        type: DELETE_ACTIONS.UPDATE_DATA,
        payload: {
          data: this.props.data.data,
          tableCode: this.props.data.code,
          idName: 'Id',
          selectedItems: this.deletionState.selectedItems,
        },
      });
      this.dispatch({ type: DELETE_ACTIONS.GENERATE_ALLOWED_ITEMS_LIST });

      this.props.setAppState((prevState) => {
        return {
          templates: {
            ...prevState.templates,
            isInitialized: true,
          },
        };
      });
    }

    if (tabIndex < 2 && !isInitialized && !isLoading && data.length === 0) {
      this.handleTabsChange(tabIndex + 1);
    }
  }

  handleSearch() {
    const { searchType, ...globalSearchParams } = cleanSearchParams(urlSearchToObject(this.props.location.search));

    if (!equal(this.props.data.globalSearchParams, globalSearchParams)) {
      this.props.setAppState((prevState) => ({
        templates: {
          ...prevState.templates,
          shouldLoad: true,
          tabIndex: 2,
          pageNumber: 1,
          globalSearchParams,
          searchParams: {
            ...prevState.searchParams,
            Pinned: undefined,
          },
        },
      }));
    }
  }

  handleTabsChange(tabIndex) {
    const { searchValues, tabs } = this.state;
    const searchParams = searchValues[tabs[tabIndex]];

    this.props.setAppState((prevState) => {
      return {
        templates: {
          ...prevState.templates,
          searchParams,
          tabIndex,
          pageNumber: 1,
          shouldLoad: this.props.data.tabIndex !== tabIndex,
        },
      };
    });
  }

  handlePageNumberChange(pageNumber) {
    this.props.setAppState((prevState) => ({
      templates: {
        ...prevState.templates,
        shouldLoad: true,
        pageNumber,
      },
    }));
  }

  handleSearchDownload() {
    const { searchType, ...globalSearchParams } = cleanSearchParams(urlSearchToObject(this.props.location.search));

    DownloadFromUrl(buildUrl(TEMPLATES_EXCEL, globalSearchParams));
  }

  handleCancelDelete() {
    this.setState({
      itemToDelete: undefined,
      isShowDeleteConfirmation: false,
    });
  }

  handleProceedDelete() {
    this.dispatch({ type: DELETE_ACTIONS.DEACTIVATE_DELETE_CONFIRMATION });

    this.props.setAppState((prevState) => ({
      templates: {
        ...prevState.templates,
        isDeleting: true,
      },
      isCreatingObject: true,
    }));

    this.setState({
      itemToDelete: undefined,
      isShowDeleteConfirmation: false,
    });

    //! for some reasons, the deletionState object is not accessible from the function, I had to link it locally here.
    //! The dispatch works tho!

    //! FIXME: This caused me lots of issues until I found the solution below.
    const deletionState = this.context.deletionState;

    // ! list of items to be deleted:
    let itemsList = [];

    // ! Choosing what list to be submitted for deletion,
    // ! the one in the deleteState or the one in the component state:
    if (!deletionState.isDeletionModeActive) {
      itemsList.push(this.state.itemToDelete);
    } else {
      itemsList = deletionState.selectedItems;
    }

    Fetch.Delete(`${TEMPLATES}?isMultiDelete=true`, { idList: itemsList })
      // Fetch.Delete(TEMPLATES, { idList: this.deletionState.selectedItems })
      .then(() =>
        this.props.setAppState((prevState) => {
          // ! On Successful deletion in either list, reset the deletionState object and keep:
          // ! refresh the data from the component did mount/update:
          this.dispatch({ type: DELETE_ACTIONS.SUCCESSFUL_DELETION });

          return {
            templates: {
              ...prevState.templates,
              shouldLoad: true,
            },
          };
        }),
      )
      .finally(() =>
        this.props.setAppState((prevState) => {
          this.dispatch({
            type: DELETE_ACTIONS.DEACTIVATE_DELETE_CONFIRMATION,
          });

          return {
            templates: {
              ...prevState.templates,
              isDeleting: false,
            },
            isCreatingObject: false,
          };
        }),
      );
  }

  rowRules(option, row) {
    if (
      option &&
      row &&
      this &&
      this.hasOwnProperty('props') &&
      this.props.hasOwnProperty('userName') &&
      this.hasOwnProperty('deletionState') &&
      this.deletionState.hasOwnProperty('userInfo')
    ) {
      return rowRules.template(option, row, this.props.userName, this.deletionState.userInfo) || false;
    }

    return false;
  }

  render() {
    const { props, state, handleProceedDelete } = this;
    const { deletionState, dispatch } = this.context;

    const sharedProps = {
      globalSearch: urlSearchToObject(this.props.location.search),
      onPinClick: this.onPinClick,
      setPageState: this.setPageState,
      menuOptions,
      onTabsChange: this.handleTabsChange,
      onPageChange: this.handlePageNumberChange,
      onPageSizeChange: this.handlePageSizeChange,
      onSearchDownload: this.handleSearchDownload,
      onOptionClick: this.onOptionClick,
      rowRules: this.rowRules,
    };

    return (
      <Fragment>
        <ContentSwitch index={props.deviceIndex} {...state} {...props} {...sharedProps}>
          <TemplatesMobile />
          <TemplatesDesktop />
        </ContentSwitch>

        {deletionState.isDeleteConfirmationActive && (
          <ConfirmDelete
            title={i18n.t('multiDeletion:MultiDeleteRecordsConfirmation')}
            onCancelDelete={() => {
              dispatch({ type: DELETE_ACTIONS.DEACTIVATE_DELETE_CONFIRMATION });
            }}
            onProceedDelete={() => {
              handleProceedDelete();
            }}
          />
        )}
      </Fragment>
    );
  }
}

Templates.propTypes = {
  setHeadTitle: PropTypes.func,
  setAppState: PropTypes.func,
  data: PropTypes.shape({
    isLoading: PropTypes.bool,
    isInitialized: PropTypes.bool,
    code: PropTypes.string,
    abortController: PropTypes.shape({
      abort: PropTypes.func,
    }),
    data: PropTypes.arrayOf(PropTypes.shape({})),
    tabIndex: PropTypes.number,
    globalSearchParams: PropTypes.shape({}),
  }),
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
  filterItemValue: PropTypes.string,
  submissionTypes: PropTypes.arrayOf(PropTypes.shape({})),
  onAPIError: PropTypes.func,
  userName: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  isSupplyWarningON: PropTypes.bool,
  isTemplateWarningON: PropTypes.bool,
  isSubmissionWarningON: PropTypes.bool,
  isPrepaid: PropTypes.bool,
};

export default Templates;



// WEBPACK FOOTER //
// ./src/containers/Templates/Templates.jsx